module.exports = __webpack_public_path__ + "assets/img/init_pos_wallpaper4.a6d223fa.png";